const C = {
  name: "RefreshSmallSquare",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19 5V11H13V9H15.9994C15.0744 7.76609 13.603 7 12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C14.42 17 16.44 15.28 16.9 13H18.92C18.44 16.39 15.52 19 12 19C8.14 19 5 15.86 5 12C5 8.14 8.14 5 12 5C13.9177 5 15.7094 5.78908 17 7.10348V5H19Z" fill="currentColor"/>
<path d="M1 4C1 2.34315 2.34315 1 4 1H20C21.6569 1 23 2.34315 23 4V20C23 21.6569 21.6569 23 20 23H4C2.34315 23 1 21.6569 1 20V4ZM4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3H4Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as RefreshSmallSquare
};
